import { render, staticRenderFns } from "./TrailLoader.vue?vue&type=template&id=23737396&functional=true"
var script = {}
import style0 from "./TrailLoader.vue?vue&type=style&index=0&id=23737396&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports